import { connect } from 'react-redux'
import * as RX from 'reactxp';
import OutlineBox from '../../components/outline_box';
import * as ReactGA from '../../modules/google_analytics';

import { WebViewSandboxMode } from 'reactxp/dist/common/Types';
import t from '../../utils/i18n'
import { mapStateToProps } from '../../utils/mapper';
import { body, colors, h1 } from '../../utils/styles';

import { md, sm } from 'src/utils/breakpoints';

const styles = {
  header: RX.Styles.createTextStyle({
    color: colors.header,
    textAlign: 'left',
  }),
  wrapper: RX.Styles.createViewStyle({
    marginBottom: 8
  }),
};

class Feedback extends RX.Component<{
  window: { width: number, height: number, multiplier: number, landscape: boolean } }, RX.CommonProps> {

  constructor(props: { window: { width: number, height: number, multiplier: number, landscape: boolean } }) {
    super(props);
  }

  public componentDidMount() {
    ReactGA.trackEvent(
      'Go to Feedback',
      'Navigation',
    );
  }

  public render() {
    let { window: { width } } = this.props;
    const { window: { height, multiplier, landscape }} = this.props;
    width = width - (landscape ? 112 : 64) * multiplier;

    /* Both header and copy are being set here because setting them inside
       the RX.Text element causes them to not appear.*/
    const feedbackHeader = t('urgentCare.header.title');
    const feedbackCopy = t('urgentCare.header.copy');
    return (
      <RX.View>
        <RX.View style={styles.wrapper}>
          <RX.Text style={[h1(multiplier), styles.header]}>{feedbackHeader}</RX.Text>
        </RX.View>
        <RX.View style={styles.wrapper}>
          <RX.Text style={[body(multiplier)]}>{feedbackCopy}</RX.Text>
        </RX.View>
        <RX.View>
          <OutlineBox>
            <iframe src='https://www.lghealthurgentcare.org/locationdata.aspx' frameBorder='0'
              height={(sm > width ? 4000 : 2200)} width='100%' ></iframe>
            {/* <RX.WebView
              sandbox={WebViewSandboxMode.AllowScripts}
              style={{
                height: ((multiplier > 1) ? 4000 : 2000),
                minHeight: 350 * multiplier,
                // width,
              }}
              url='https://www.lghealthurgentcare.org/locationdata.aspx'
            /> */}
          </OutlineBox>
        </RX.View>
      </RX.View>
    );
  }
}

export default connect(mapStateToProps)(Feedback);



// WEBPACK FOOTER //
// ./src/pages/urgent_care/index.tsx